import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import PriceCheckRoundedIcon from '@mui/icons-material/PriceCheckRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import HouseRoundedIcon from '@mui/icons-material/HouseRounded';
import HandymanRoundedIcon from '@mui/icons-material/HandymanRounded';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import LocalSeeRoundedIcon from '@mui/icons-material/LocalSeeRounded';
import ChairRoundedIcon from '@mui/icons-material/ChairRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import RecommendRoundedIcon from '@mui/icons-material/RecommendRounded';
import CurrencyExchangeRoundedIcon from '@mui/icons-material/CurrencyExchangeRounded';
import DesignServicesIcon from '@mui/icons-material/DesignServices';

const mainListItems = [
  { text: 'Home', icon: <HomeRoundedIcon /> },
  { text: 'Map', icon: <PlaceRoundedIcon /> },
  { text: 'Cash Offer', icon: <CurrencyExchangeRoundedIcon /> },
  { text: 'Financing', icon: <PriceCheckRoundedIcon /> },
  { text: 'Create Listing', icon: <HouseRoundedIcon /> },
  { text: 'Buy Listing', icon: <HomeWorkRoundedIcon /> },
  { text: 'Renovations', icon: <HandymanRoundedIcon /> },
  { text: 'Stage', icon: <ChairRoundedIcon /> },
  { text: 'Photos', icon: <LocalSeeRoundedIcon /> },
  { text: 'Boost Marketing', icon: <CampaignRoundedIcon /> },
  { text: 'Get Help', icon: <GroupsRoundedIcon /> },
  { text: 'Admin', icon: <DesignServicesIcon /> },
];

const secondaryListItems = [
  { text: 'About', icon: <InfoRoundedIcon /> },
  { text: 'Feedback', icon: <HelpRoundedIcon /> },
  { text: 'Follow Us', icon: <RecommendRoundedIcon /> },
];

export default function MenuContent({ onSelect }) {
  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton onClick={() => onSelect(item.text)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton onClick={() => onSelect(item.text)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}

